<template>
  <div class="game-intro">
    <h2 class="h2 game-intro__name">{{ game.gameName }}</h2>
    <div class="game-intro__meta">
      <div class="grid grid--b20 grid--middle grid--auto">
        <div class="grid__item">
          <GameDates :game="game"></GameDates>
        </div>
        <div class="grid__item">
          <div class="grid grid--g6 grid--auto grid--middle">
            <div class="grid__item" v-for="channel in game.channels">
              <span class="fonticon game-intro__channel" v-bind:class="'fonticon--' + channel"></span>
            </div>
          </div>
        </div>
        <div class="grid__item" v-if="game.partner[0].logo">
          <img
            class="game-intro__partner-logo"
            :src="game.partner[0].logo.href"
            :alt="game.partner[0].name"
          />
        </div>
      </div>
    </div>
    <div v-html="game.gameDescription" class="game-intro__description"></div>
    <div class="grid grid--b32--not-phab grid--b12--phab grid--middle grid--auto game-intro__actions">
      <div class="grid__item">
        <PlayGameButton
          v-if="$root.gameHasDemo(game)"
          :game="game"
        />
        <btn v-else class="btn--shape--h48--not-phab w--100p btn--style btn--coming-soon" disabled>Demo Coming Soon
        </btn>
      </div>
      <div class="grid__item" v-if="game.gameCentre && game.gameCentre.length > 0 && game.gameCentre[0].hasChildren">
        <DownloadAssetsButton :game="game"></DownloadAssetsButton>
      </div>
    </div>
  </div>
</template>

<script>
import GameDates from '../molecules/GameDates'
import PlayGameButton from '../organisms/PlayGameButton'
import DownloadAssetsButton from '../organisms/DownloadAssetsButton'
import Btn from '../atoms/Btn'

export default {
  name: 'GameIntro',
  components: {
    GameDates,
    PlayGameButton,
    DownloadAssetsButton,
    Btn
  },
  props: {
    game: Object
  }
}
</script>

<style lang="scss">
@import "src/scss/toolkit";

.btn--coming-soon {
  color: #333;
  background: #ddd;
}

.game-intro {

  &__meta {
    margin-bottom: rem(24);
  }

  &__date {
    @include extend(h5);
    margin-bottom: rem(8);
  }

  &__channel {
    font-size: rem(32);
  }

  &__description {
    color: palette('grey');

    @include media(not-phab) {
      max-width: 536px;
    }

    a {
      color: #0179FF !important;
      font-weight: bold;
    }
  }

  &__partner-logo {
    margin-left: rem(4);
    height: 100%;
    max-height: rem(52);
    width: auto;
    max-width: rem(128);
  }

  &__actions {
    margin-top: rem(36);
  }
}

</style>



// WEBPACK FOOTER //
// src/components/molecules/GameIntro.vue